// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
.Header {
  background-color: var(--color-bg);
  color: var(--color-fg);
  position: fixed;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-color);
  width: 100%;
  top: 0;
  left: 0;
  transition: transform var(--transition-time) ease-in-out;
  z-index: 2;
  box-shadow: 0 20px 5px rgba(0, 0, 0, 0.1);
}

.Header.visible {
  transform: translateY(0);
}

.Header.hidden {
  transform: translateY(-100%);
}

.Header-content {
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: 3fr 6fr 3fr;
  margin: 0 2rem;
}

.Header-logo {
  font-size: 1.5rem;
  text-decoration: none;
  color: var(--color-fg);
  margin-right: auto;
}

.Header-nav {
  display: flex;
  gap: 2.5rem;
  flex-grow: 1;
  justify-content: center;
}

.Header-nav-item {
  text-decoration: none;
  color: var(--color-fg);
}

.Header-nav-item:hover {
  color: var(--color-hover);
}

.actionsContainer {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/*Adding Mobile styles*/
@media (max-width: 767px) {
  .Header-nav {
    display: none;
  }
  .Header-content {
    grid-template-columns: 1fr 8fr 3fr;
    margin: 0 0.5rem;
    gap: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Header.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,iCAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,wDAAA;EACA,UAAA;EACA,yCAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAGA;EACI,4BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,cAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAGA,uBAAA;ADxDE;EC0DE;IACI,aAAA;EAAN;EAEE;IACI,kCAAA;IACA,gBAAA;IACA,WAAA;EAAN;AACF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use '../styles';\n\n.Header {\n    background-color: var(--color-bg);\n    color: var(--color-fg);\n    position: fixed;\n    padding: 0.5rem 0;\n    border-bottom: 1px solid var(--border-color);\n    width: 100%;\n    top: 0;\n    left: 0;\n    transition: transform var(--transition-time) ease-in-out;\n    z-index: 2;\n    box-shadow: 0 20px 5px rgba(0, 0, 0, 0.1);\n}\n\n.Header.visible {\n    transform: translateY(0);\n}\n\n.Header.hidden {\n    transform: translateY(-100%);\n}\n\n.Header-content {\n    display: grid;\n    justify-content: space-between;\n    align-items: center;\n    grid-template-columns: 3fr 6fr 3fr;\n    margin: 0 2rem;\n}\n\n.Header-logo {\n    font-size: 1.5rem;\n    text-decoration: none;\n    color: var(--color-fg);\n    margin-right: auto;\n}\n\n.Header-nav {\n    display: flex;\n    gap: 2.5rem;\n    flex-grow: 1;\n    justify-content: center;\n}\n\n.Header-nav-item {\n    text-decoration: none;\n    color: var(--color-fg);\n}\n\n.Header-nav-item:hover {\n    color: var(--color-hover);\n}\n\n.actionsContainer {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n\n/*Adding Mobile styles*/\n@include styles.mobile {\n    .Header-nav {\n        display: none;\n    }\n    .Header-content {\n        grid-template-columns: 1fr 8fr 3fr;\n        margin: 0 0.5rem;\n        gap: 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
